import React from "react";
import CookieConsent from "react-cookie-consent";
//import Navbar from "../components/navbar";
import Newnav from "../components/newnav";
//import About from "../components/about";
//import Feature from "../components/feature";
import Aboutcompany from "../components/aboutcompany";
import Awardcompany from "../components/awardcompany";
//import ScreenShot from "../components/screenshot";
// import Team from "./components/team";
// import Blog from "./components/blog";
// import Price from "./components/price";
//import Testimonial from "../components/testimonial";
//import Contact from "../components/contact";
//import Subscribe from "../components/subscribe";
import Footer from "../components/footer";
//import Tilt from "react-tilt";
//import { Icon } from "@iconify/react";
//import mobileOutline from "@iconify/icons-ant-design/mobile-outline";
//import qrcodeOutline from "@iconify/icons-ant-design/qrcode-outline";

class Company extends React.Component {
  render() {
    document.body.classList.remove("landing-page");
    document.body.classList.remove("home-style");
    document.body.classList.remove("three");
    document.body.classList.remove("home-style-two");
    return (
      <div>
        {/* Navbar Component*/}
        {/* <Navbar /> */}
        <Newnav />

        {/* Home One Section Start */}
        {/*
        <section id="home" className="home">
          <div className="home-decor">
            <div className="home-circle1">
              <img src="assets/images/main-banner3.png" alt="" />
            </div>
            <div className="home-circle2">
              <Icon
                style={{ marginRight: 90, marginTop: 180 }}
                width={50}
                height={50}
                icon={qrcodeOutline}
        /> */}
        {/* <img src="assets/images/main-banner12.png" alt="" /> */}
        {/*</div>
            <div className="home-circle3">
            <Icon width={160} height={280} icon={mobileOutline} />*/}
        {/* <img src="assets/images/main-banner1.png" alt="" /> */}
        {/* </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-5">
                <div className="home-contain">
                  <div>
                    <img
                      src="assets/images/logoimage.png"
                      alt="caption-img"
                      className="caption-img"
                    />
                    <h4>ΓΝΩΡΙΣΤΕ ΤΟ</h4>
                    <h1>
                      q<span className="f-bold">r</span>
                      <span className="f-bold f-color">stand</span>
                    </h1>
                    <p>
                      Η επαναστατική εφαρμογή που ο επισκέπτης με τον εκθέτη θα
                      έχουν άμεση επικοινωνία.
                    </p>
                    <a href="https://apps.apple.com/app/id1467479271">
                      <img
                        src="assets/images/appstore.png"
                        alt="appstore"
                        className="store"
                      />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=gr.progressnet.qrstand">
                      <img
                        className="ml-10 store"
                        src="assets/images/play-store.png"
                        alt="play-store"
                      />
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 offset-md-1">
                <div className="home-right">
                  <Tilt
                    options={{
                      perspective: 110,
                      speed: 400,
                      max: 1.2,
                      scale: 1,
                    }}
                  >
                    <img
                      src="assets/images/mobile.png"
                      className="img-fluid"
                      alt="mobile"
                    />
                  </Tilt>
                </div>
              </div>
            </div>
          </div>
        </section>
                */}
        {/* Home One Section End */}

        {/* About Component*/}
        {/* <About /> */}

        {/*Feature Component*/}
        {/* <Feature /> */}
        <Aboutcompany />

        {/*ScreenShot Component*/}
        <Awardcompany />

        {/*Team Component*/}
        {/* <Team /> */}

        {/*Blog Component*/}
        {/* <Blog /> */}

        {/*Price Component*/}
        {/* <Price /> */}

        {/*Testimonial Component*/}
        {/* <Testimonial /> */}

        {/*Contact Component*/}
        {/* <Contact /> */}

        {/*Subscription Component*/}
        {/* <Subscribe /> */}

        {/*Footer Component*/}
        <Footer />
        <CookieConsent
          location="bottom"
          buttonText="Συμφωνώ"
          cookieName="token"
          style={{ background: "#2B373B" }}
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={150}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "start",
              alignItems: "center",
            }}
          >
            Αυτός ο ιστότοπος χρησιμοποιεί cookies για να βελτιώσει την εμπειρία
            του χρήστη.{" "}
            <a
              style={{
                fontSize: "10px",
                color: "#fcc11a",
                textDecoration: "none",
              }}
              className="nav-link"
              href={`${process.env.PUBLIC_URL}/cookiePolicy`}
            >
              Πολιτική Cookies
            </a>
          </div>
        </CookieConsent>
      </div>
    );
  }
}

export default Company;



// WEBPACK FOOTER //
// ./src/pages/company.js